<div class="file-container">
  <div class="file-list-header" [class.file-list-header-not-displayed]="isDisabled">
    @if (!isDisabled) {
      <div class="button-group">
        <button nbButton
                status="basic"
                ghost
                (click)="selectAll()"
                nbTooltip="Alle auswählen"
                nbTooltipStatus="basic">
          <nb-icon icon="checkmark-square-2-outline" pack="eva"></nb-icon>
        </button>
        <button nbButton
                status="basic"
                ghost
                (click)="deselectAll()"
                nbTooltip="Keine auswählen"
                nbTooltipStatus="basic">
          <nb-icon icon="close-square-outline" pack="eva"></nb-icon>
        </button>
      </div>
    }
    <div class="right-section">
      @if (!isDisabled) {
        <div class="button-group">
          @if (selectedFiles.length) {
            <button nbButton
                    status="basic"
                    ghost
                    nbTooltip="Nach links drehen"
                    nbTooltipStatus="basic"
                    (click)="rotateSelection(-90)">
              <nb-icon icon="undo-outline" pack="eva"></nb-icon>
            </button>
            <button nbButton
                    status="basic"
                    ghost
                    nbTooltip="Nach rechts drehen"
                    nbTooltipStatus="basic"
                    (click)="rotateSelection(90)">
              <nb-icon class="flip-icon" icon="undo-outline" pack="eva"></nb-icon>
            </button>
            <button nbButton
                    status="danger"
                    ghost
                    nbTooltip="Löschen"
                    nbTooltipStatus="danger"
                    (click)="deleteFiles()">
              <nb-icon icon="trash-2-outline" pack="eva"></nb-icon>
            </button>
          }
        </div>
      }
    </div>
  </div>
  @if (value) {
    @if (value.length === 0 && isDisabled) {
      <div class="text-hint">
        <span>Keine angehängten Bilder oder Dateien.</span>
      </div>
    }
    @if (value.length) {
      <div class="file-list"
           cdkDropList
           cdkDropListOrientation="mixed"
           (cdkDropListDropped)="onDrop($event)">
        @for (attachment of value; track attachment.s3key; let i = $index) {
          @if (checkSelectedTags(attachment.tags) && !attachment.deleted && checkBuildingSectionFilter(attachment)) {
            <wr-attachment-preview cdkDrag
                                   [cdkDragDisabled]="isDragDisabled"
                                   [class.filtered-image]="!checkHoveredTag(attachment.tags)"
                                   [selected]="isSelected(i)"
                                   [isDisabled]="isDisabled"
                                   (imageEditClick)="toggleSelect(i)"
                                   [attachment]="attachment"
                                   (tagsEditClick)="showAttachmentDialog(attachment)">
            </wr-attachment-preview>
          }
        }
      </div>
    }
  }
  @if (!isDisabled) {
    <wr-attachment-upload-section [attachments]="value"
                                  [formControlContext]="currentControlContext"
                                  [filterBuildingSectionId]="filterBuildingSectionId()">
    </wr-attachment-upload-section>
  }
  @if (value && value.length > 0 && !isDisabled) {
    <div class="tag-filter-list">
      <wr-tag-filter-list [attachments]="value"
                          (hoveredTagChange)="hoveredTagChange($event)"
                          (selectedTagsChange)="onSelectedTagsChange($event)">
      </wr-tag-filter-list>
    </div>
  }
</div>
